import React, { FC } from 'react';
import './styles.scss';

export const PageNotFound: FC = () => {
  return (
    <div className="page-not-found-wrapper">
      <h3 className="page-not-found-wrapper__title">Page not found.</h3>
    </div>
  );
};
